// api desarrollo
// export const BASE_PATH = "http://localhost:1337"

//api produccion
export const BASE_PATH = 'https://api.aginpro.com'

export const FormatDate = 'YYYY-MM-DD'
